import { render, staticRenderFns } from "./OEENYX.vue?vue&type=template&id=1f2ed4b0&scoped=true&"
import script from "./OEENYX.vue?vue&type=script&lang=js&"
export * from "./OEENYX.vue?vue&type=script&lang=js&"
import style0 from "./OEENYX.vue?vue&type=style&index=0&id=1f2ed4b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2ed4b0",
  null
  
)

export default component.exports